import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import PageLayout from '@/components/PageLayout';
import { isReadyLang, redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { getCategoryList } from '@/service';
import PCLayout from '@/components/accessories';
import H5Layout from '@/componentsH5/accessories';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/accessories';

const Accessories = ({ lang, SEO, categories }: any) => {
    const { isMobile } = useGlobal();
    const LayoutCom = isMobile ? H5Layout : PCLayout;
    const router = useRouter();

    return (
        <PageLayout>
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || ''} />
            <SEOlinksA locale={router.locale || 'us'} list={seoconfig.include} pathname={router.asPath.substr(1)} />
            <LayoutCom lang={lang} categoryList={categories} />
        </PageLayout>
    );
};

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
    if (!isReadyLang(locale as string)) redirectTo404();
    let categories: any = [];
    try {
        const resCategory = await getCategoryList(locale);
        if (resCategory.code === '0') {
            categories = resCategory?.data;
        }
    } catch (err) {
        console.log(err);
    }

    return {
        props: {
            categories,
        },
    };
};

export default Accessories;
